export default "__VITE_ASSET__BdQU8Nrm__"